export const ERROR_MESSAGES: Record<string, string> = {
  ProblemaDadosEnviados: "Verifique os dados preenchidos e tente novamente",
  UsuarioNaoCadastrado: "Usuário não encontrado",
  CredenciaisInvalidas: "Usuário e/ou senha incorreto(s)",
  PlanoCancelado: "Seu plano foi cancelado",
  ProblemaPagamento:
    "Houve um problema no durante o pagamento da sua assinatura",
  FalhaConexao:
    "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.",
  ErroServidor:
    "Nosso servidor está com um problema no momento. Não é a sua internet. Tente novamente em alguns minutos.",
  ErroCadastro:
    "Não foi possível concluir o cadastro. Verifique os dados e tente novamente.",
  ErroInesperado:
    "Não foi possível entrar agora. Tente novamente em alguns instantes.",
};
